var _style, _circle, _polygon, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateNoData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b9950e65-c983-427f-969f-411e60d4718f",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 488.6 488.6",
    style: {
      enableBackground: "new 0 0 488.6 488.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7F9FA;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#BDC5D1;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill:#E7EAF3;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#E7EAF3;}\n\t.st5{opacity:5.000000e-02;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    className: "st0",
    cx: 244.3,
    cy: 244.3,
    r: 244.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "47.4,297.1 106.5,224 382.8,224 441.4,297.1 441.4,407.7 47.4,407.7 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.8,45.2H105.1c-2.3,0-4.2,1.9-4.2,4.2v301c0,2.3,1.9,4.2,4.2,4.2h278.6c2.3,0,4.2-1.9,4.2-4.2V100.2 L332.8,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387.8,100.2l-55-55h-0.2l8.5,55.6c1.2,7.9,8.6,13.3,16.4,12.1l30.3-4.6L387.8,100.2L387.8,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.8,192.8H160.6c-3.5,0-6.3-2.8-6.3-6.3v-85.1c0-3.5,2.8-6.3,6.3-6.3h169.2c3.5,0,6.3,2.8,6.3,6.3v85.1 C336.1,189.9,333.3,192.8,329.8,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.8,192.8H160.6c-3.5,0-6.3-2.8-6.3-6.3v-85.1c0-3.5,2.8-6.3,6.3-6.3h169.2c3.5,0,6.3,2.8,6.3,6.3v85.1 C336.1,189.9,333.3,192.8,329.8,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M326.7,232.1H162c-1.3,0-2.4-1.1-2.4-2.4l0,0c0-1.3,1.1-2.4,2.4-2.4h164.8c1.3,0,2.4,1.1,2.4,2.4l0,0 C329.2,231,328.1,232.1,326.7,232.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M326.7,250.3H162c-1.3,0-2.4-1.1-2.4-2.4l0,0c0-1.3,1.1-2.4,2.4-2.4h164.8c1.3,0,2.4,1.1,2.4,2.4l0,0 C329.2,249.2,328.1,250.3,326.7,250.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M280,268.6H162c-1.3,0-2.4-1.1-2.4-2.4l0,0c0-1.3,1.1-2.4,2.4-2.4h118.1c1.3,0,2.4,1.1,2.4,2.4l0,0 C282.5,267.5,281.4,268.6,280,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.1,163.2c1.1-3.2,2.4-6.4,3.9-9.4c2.5-5.1,5.8-10.6,10.8-13.7c6.3-3.9,12.2-0.3,16.6,4.7 c3.5,4,6.8,8.4,11.7,10.7c3.8,1.8,8,2.1,12,1c6.4-1.7,11.8-6.3,16-11.2c0.5-0.6,1-1.2,1.5-1.9c3.1-4.4,5.3-10.6,1.4-15.2 c-0.7-0.8-1.5-1.5-2.5-2.1c-2.2-1.3-5-1.8-7.4-1.1c-2.6,0.7-4.3,2.9-4.7,5.5c-0.1,0.4-0.1,0.9-0.1,1.3c-0.1,4.4,2.6,8.5,5.7,11.5 c5.9,5.6,14.3,7.8,22.2,8.2c3.1,0.2,6.1,0,9.2-0.3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M345.5,297.1c-10.9,0-19.8,8.8-19.8,19.7c0,10.9-8.8,19.7-19.7,19.7h-61.7h-61.7c-10.9,0-19.7-8.8-19.7-19.7 c0-10.9-8.8-19.7-19.8-19.7H46.8v120c0,15.7,12.8,28.5,28.5,28.5h169h169c15.7,0,28.5-12.8,28.5-28.5v-120H345.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoData);
export default __webpack_public_path__ + "static/media/empty-state-no-data.40d4f47751c1a6f9e6a0b7ac964c95df.svg";
export { ForwardRef as ReactComponent };